import { render, staticRenderFns } from "./Ingredient.vue?vue&type=template&id=a92b3220"
import script from "./Ingredient.vue?vue&type=script&lang=js"
export * from "./Ingredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports